import { render, staticRenderFns } from "./EbookContentDashboard.vue?vue&type=template&id=4226f7fc&scoped=true&"
import script from "./EbookContentDashboard.vue?vue&type=script&lang=js&"
export * from "./EbookContentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EbookContentDashboard.vue?vue&type=style&index=0&id=4226f7fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4226f7fc",
  null
  
)

export default component.exports